import { combineReducers } from 'redux';
import { loadingBarReducer as loadingBar } from 'react-redux-loading-bar';

import cms from 'app/modules/cms/service/store/cms-reducer';
import { CmsState } from 'app/modules/cms/service/store/cms-state';
import { CorporateState } from 'app/modules/corporate/service/store/corporate.state';
import offers from 'app/modules/corporate/service/store/corporate.reducer';
import { ConfigState } from 'app/modules/config/service/store/config.state';
import config from 'app/modules/config/service/store/config.reducer';
import { GtmState } from 'app/modules/gtm/service/store/gtm.state';
import gtm from 'app/modules/gtm/service/store/gtm.reducer';
import { SubscriptionState } from 'app/modules/subscription/service/store/subscription-state';
import subscription from 'app/modules/subscription/service/store/subscription-reducer';
import { CustomerState } from 'app/modules/customer/service/store/customer.state';
import customer from 'app/modules/customer/service/store/customer.reducer';
import { LocaleState } from 'app/modules/locale/service/store/locale.state';
import locale from 'app/modules/locale/service/store/locale.reducer';
/* jhipster-needle-add-reducer-import - JHipster will add reducer here */
import { StepState } from 'app/modules/journey/service/store/step.state';
import step from 'app/modules/journey/service/store/step.reducer';
import corporate from 'app/modules/corporate/service/store/corporate.reducer';
import insuredElementData from 'app/modules/transverse/service/store/insuredElement.reducer';
import { InsuredElementState } from 'app/modules/transverse/service/store/insuredElement.state';

export interface IRootState {
  readonly locale: LocaleState;
  readonly step: StepState;
  /* jhipster-needle-add-reducer-type - JHipster will add reducer type here */
  readonly loadingBar: any;
  readonly offers: CorporateState;
  readonly config: ConfigState;
  readonly subscription: SubscriptionState;
  readonly cms: CmsState;
  readonly gtm: GtmState;
  readonly customer: CustomerState;
  readonly corporate: CorporateState;
  readonly insuredElementData: InsuredElementState;
}

const rootReducer = combineReducers<IRootState>({
  locale,
  step,
  /* jhipster-needle-add-reducer-combine - JHipster will add reducer here */
  loadingBar,
  offers,
  config,
  subscription,
  cms,
  gtm,
  customer,
  corporate,
  insuredElementData
});

export default rootReducer;
